import { render, staticRenderFns } from "./index.vue?vue&type=template&id=269441c1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269441c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269441c1')) {
      api.createRecord('269441c1', component.options)
    } else {
      api.reload('269441c1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=269441c1&scoped=true", function () {
      api.rerender('269441c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/identityManager/index.vue"
export default component.exports